import { useCallback } from 'react';
import {
  logger as LOG,
  useNoticeBannersStackContext,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

LOG.enable('ApplePay');
const logger = LOG.extend('ApplePay');

export function useApplePayErrorHandling() {
  const { t } = useLocalizationContext();
  const { push: addNoticeBanner } = useNoticeBannersStackContext();

  return useCallback(
    (error?: Readonly<{ message?: string }>) => {
      logger.error(error);

      addNoticeBanner({
        text: error?.message ?? t('general.apple-pay-error'),
        palette: 'caution',
      });
    },
    [t, addNoticeBanner],
  );
}
